import React from 'react';
import { useNavigate } from 'react-router-dom';

import { deletePayer } from 'api/Payer';

import { useCustomMutation } from 'lib/hooks/useCustomMutation';
import useModal from 'lib/hooks/useModal';

import { withErrorBoundary } from 'components/shared/Error/Boundary';
import Popover from 'components/shared/Popovers/Popover/Popover';

import PayerModal from './PayerModal';

const Actions = ({ data, practiceId }) => {
  const navigate = useNavigate();

  const { isOpen, openModal, closeModal } = useModal();

  const { mutate: handleDeletePayer } = useCustomMutation({
    mutationFn: ({ payerId }) => deletePayer(navigate, { payerId, practiceId }),
    successMessage: 'Payer deleted successfully!',
    invalidateQueryKey: ['payers', data?.status === 1 && 'payers-search'] // refetch payers-search if payer is active
  });

  const options = [
    { label: 'Edit', icon: 'edit-2-mono', onClick: openModal },
    { label: 'Delete', icon: 'trash-mono', onClick: () => handleDeletePayer({ payerId: data?.id }) }
  ];

  return (
    <>
      <Popover
        className="flex h-full w-full items-center justify-center"
        position="left"
        isFixed
        icon="context-menu-horizontal"
        options={options}
        isBorder={false}
      />

      {isOpen && (
        <PayerModal
          payerId={data?.id}
          practiceId={practiceId}
          isOpen={isOpen}
          handleClose={closeModal}
        />
      )}
    </>
  );
};

export default withErrorBoundary(Actions);
